function Is4K() {
  return window.matchMedia('(max-width: 2565px) and (min-width: 2000px)')
    .matches;
}
export default Is4K;
